<!-- HW600 大载重直升机 -->
<template>
  <div class='template-container'>
    <div class="main-box1">
      <div class="text-box">
        <div class="text-top">
          <div class="text-item" style="flex: 1">
            <div class="top-text1">HW-600H</div>
            <div>{{ $t('hw600.text1') }}</div>
          </div>
          <img class="img-lj" src="/static/images/v2/600h/lj.png">
          <div class="text-item">
            <div class="top-text2">200+kg</div>
            <div class="top-text2-1">{{ $t('hw600.text2') }}</div>
          </div>
          <img class="img-lj" src="/static/images/v2/600h/lj.png">
          <div class="text-item">
            <div class="top-text2">8h</div>
            <div class="top-text2-1">{{ $t('hw600.text3') }}</div>
          </div>
          <img class="img-lj" src="/static/images/v2/600h/lj.png">
          <div class="text-item" style="width: auto">
            <div class="top-text2">300km</div>
            <div class="top-text2-1">{{ $t('hw600.text4') }}</div>
          </div>
        </div>
        <div class="box1-intro">
          {{ $t('hw600.text5') }}
        </div>
      </div>
    </div>
    <div class="main-box2">
      <div style="height: 62px"></div>
      <img class="main-box2-img"
           src="/static/images/v2/600h/600h_bg2_1.png">
      <div class="box2-right">
        <div class="box2-item">
          <img class="img-icon" src="/static/images/v2/icon/icon1.png">
          <div>
            <div class="box2-item-title">
              {{ $t('hw600.text6') }}
            </div>
            <div class="box2-item-text">
              {{ $t('hw600.text7') }}
            </div>
          </div>
        </div>
        <div class="box2-item">
          <img class="img-icon" src="/static/images/v2/icon/icon2.png">
          <div>
            <div class="box2-item-title">
              {{ $t('hw600.text8') }}
            </div>
            <div class="box2-item-text">
              {{ $t('hw600.text9') }}
            </div>
          </div>
        </div>
        <div class="box2-item">
          <img class="img-icon" src="/static/images/v2/icon/icon3.png">
          <div>
            <div class="box2-item-title">
              {{ $t('hw600.text10') }}
            </div>
            <div class="box2-item-text">
              {{ $t('hw600.text11') }}
            </div>
          </div>
        </div>
        <div class="box2-item">
          <img class="img-icon" src="/static/images/v2/icon/icon4.png">
          <div>
            <div class="box2-item-title">
              {{ $t('hw600.text12') }}
            </div>
            <div class="box2-item-text">
              {{ $t('hw600.text13') }}
            </div>
          </div>
        </div>
        <div class="box2-item">
          <img class="img-icon" src="/static/images/v2/icon/icon5.png">
          <div>
            <div class="box2-item-title">
              {{ $t('hw600.text14') }}
            </div>
            <div class="box2-item-text">
              {{ $t('hw600.text15') }}
            </div>
          </div>
        </div>
      </div>

      <div class="box2-bottom">
        <div class="content-box">
          <div class="box2-bottom-title">{{ $t('hw600.text16') }}</div>
          <div style="max-width: 638px">{{ $t('hw600.text17') }}
          </div>
        </div>
        <div class="content-box box2-bottom-list">
          <img class="box2-bottom-img" src="/static/images/v2/600h/shsd1.png">
          <img class="box2-bottom-img2" src="/static/images/v2/600h/shsd2.png">
          <img class="box2-bottom-img2" src="/static/images/v2/600h/shsd3.png">
        </div>
      </div>
      <div class="triangle-clip1"></div>
    </div>
    <div class="main-box3">
      <div class="triangle-clip"></div>
      <!--      <div class="box3-op"></div>-->
      <div style="height: 50px"></div>
      <div class="box3-task">
        <img :src="taskInfo.url" class="box3-logo">
        <div class="box3-task-text">
          <div class="box3-task-title">{{ $t('hw600.text18') }}</div>
          <div style="border-bottom: 1px solid rgba(255, 255, 255, 0.51);margin-top: 20px;margin-bottom: 54px">
            <div v-for="(v, i) in $t('hw600.taskLoad')" :key="i">
              <div>{{ v.title }}</div>
              <div class="task-item-box">
                <div v-for="(item, index) in v.list" :key="index" :class="taskInfo.name===item.name?'task-item-text2':''" class="task-item-text"
                     @click="clickLoad(item)">
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>
          <div class="task-intro-box">
            <img :src="taskInfo.url_load" class="task-intro-img">
            <div class="task-intro-title">{{ taskInfo.name }}</div>
            <div v-for="(item, index) in taskInfo.info" :key="index" class="task-intro-text">{{ item }}</div>
          </div>
        </div>
      </div>
      <div class="box3-params">
<!--        <div class="params-title">{{ $t('hw600.text19') }}</div>-->
<!--        <div class="params-grid">-->
<!--          <div v-for="(item,index) in $t('hw600.paramsList')" :key="index" class="params-grid-item">-->
<!--            {{ item.title }}-->
<!--            <div class="grid-item-text">-->
<!--              <div class="grid-line"></div>-->
<!--              <div class="grid-tip">-->
<!--                {{ item.info }}-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import MultiDomainApplication from "@/components/multiDomainApplication";


export default {
  data() {
    return {
      isMobile: false,
      taskInfo: {},

    };
  },
  created() {
    this.taskInfo = this.$t('hw600.taskLoad')[0].list[0];
    console.log(this.taskInfo);
  },
  mounted() {

  },
  methods: {
    clickLoad(e) {
      this.taskInfo = e;
      console.log(this.taskInfo);
    }
  },
  components: {
    "multi-domain-application": MultiDomainApplication
  }
};
</script>

<style lang='stylus' scoped>
.template-container {
  overflow: hidden;
  min-width: 1280px;
  width: 100%;

  .content-box {
    width: 1280px;
  }

  .main-box1 {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    background-size: cover;
    background-image: url("/static/images/v2/600h/600h_bg1.png");
    width: 100%;
    height: calc(100vh - 60px);

    .box1-intro {
      font-size: 16px;
      font-weight: 600;
      line-height: 22px;
    }

    .text-box {
      width: 1280px;
      color: #fff;
      margin-bottom: 50px;
    }

    .img-lj {
      width: 52px;
      height: 52px;
      margin-right: 15px;
    }

    .text-item {
      color: #C1C7C9;
      font-size: 24px;
      font-weight: 500;
      width: 225px;
    }

    .text-top {
      align-items: center;
      width: 100%;
      display: flex;
      padding-bottom: 20px;
      border-bottom: 1px solid #C0C1BD;
      margin-bottom: 40px;
    }

    .top-text1 {
      color: #FFFFFF;
      font-size: 64px;
      font-weight: 800;
      margin-bottom: 12px;
    }

    .top-text2 {
      color: #FFFFFF;
      font-size: 36px;
      font-weight: 900;
      margin-bottom: 12px;
    }
  }

  .main-box2 {
    position: relative;
    background-size: cover;
    background-image: url("/static/images/v2/600h/600h_bg2.png");
    width: 100%;
    height: 73.96vw;

    .main-box2-img {
      width: 1458px;
      height: 938px;
      position: absolute;
      transform: rotate(-45deg);
      top: -180px;
      left: 98px;
      z-index: 0
    }
  }

  .box2-right {
    z-index: 2;
    position: absolute;
    padding-top: 54px;
    border: 1px solid #4D4D4D;
    background: linear-gradient(90deg, #000000 0%, rgba(0, 0, 0, 0) 49%);
    width: 756px;
    margin-left: calc(100% - 758px);
  }

  .box2-item {
    margin-left: 53px;
    margin-bottom: 17px;
    display: flex;
  }

  .box2-item-title {
    margin-top: 11px;
    font-size: 24px;
    font-weight: 600;
    color: #90EEBD;
  }

  .box2-item-text {
    margin-top: 11px;
    width: 266px;
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
    color: #DCDCDC;
  }

  .img-icon {
    margin-right: 27px;
    width: 44px;
    height: 44px;
  }

  .box2-bottom {
    z-index: 10;
    left: calc((100% - 1280px) / 2);
    position: absolute;
    top: 900px;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
    color: #FFFFFF;
  }

  .box2-bottom-list {
    display: flex;
    border-top: 1px solid #4D4D4D;
    margin-top: 15px
  }

  .box2-bottom-title {
    line-height: 48px;
    font-size: 48px;
    font-weight: 600;
    background: linear-gradient(167deg, #7DDAFF 30%, #1E92F7 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    margin-bottom: 20px;
  }

  .box2-bottom-img {
    margin-top: 15px;
    width: 251px;
    height: 314px;
  }

  .box2-bottom-img2 {
    margin-top: 15px;
    margin-left: 15px;
    width: 496px;
    height: 314px;
  }

  .main-box3 {
    position: relative;
    background-size: cover;
    background-image: url("/static/images/v2/600h/600h_bg3.png");
    width: 100%;
    height: auto;
  }

  .triangle-clip1 {
    bottom: 0;
    z-index: 5;
    position: absolute;
    width: 100%;
    height: 25vw;
    background: linear-gradient(0deg, #0C0C0C 0%, rgba(0, 0, 0, 0) 100%);
  }

  .triangle-clip {
    top: -1px;
    z-index: 2;
    position: absolute;
    width: 100%;
    height: 30.34vw;
    background-color: #0C0C0C;
    clip-path: polygon(0% 0%, 0% 100%, 100% 0%);
  }

  .box3-op {
    width: 100%;
    height: 100%;
    position: absolute;
    opacity: 0.7;
    background: linear-gradient(165deg, #fff 1%, rgba(9, 117, 65, 1) 30%);;
  }

  .box3-task {
    margin-left: calc((100% - 1280px) / 2);
    width: 1280px;
  }

  .box3-logo {
    object-fit: cover;
    object-position: left;
    z-index: 5;
    position: absolute;
    top: 4vw;
    width: 950px;
    height: 947px;
  }

  .box3-task-text {
    font-size: 24px;
    color: #FFF;
    z-index: 5;
    position: absolute;
    width: 490px;
    right: calc((100% - 1280px) / 2);
    padding-bottom: 25px;
  }

  .box3-task-title {
    margin-top: 12vw;
    font-size: 48px;
    font-weight: 600;
    margin-bottom: 60px;
  }

  .task-item-box {
    display: flex;
    margin-top: 12px;
    margin-bottom: 30px;
  }

  .task-item-text {
    display: flex;align-items: center;
    justify-content: center;
    cursor: pointer;
    margin-right: 13px;
    font-size: 16px;
    font-weight: 600;
    line-height: 30px;
    text-align: center;
    width: 158px;
    min-height: 32px;
    border-radius: 3px;
    border: 1px solid #FFFFFF;
  }

  .task-item-text2 {
    background: #FFFFFF;
    color: #626262;
  }

  .task-intro-box {
    position: relative;
    border-radius: 12px;
    width: 490px;
    height: auto;
    background: linear-gradient(0deg, rgba(111, 180, 146, 0.59) 0%, #387758 100%);
    border: 1px solid rgba(255, 255, 255, 0.51);
  }

  .task-intro-img {
    left: -70px;
    top: -65px;
    width: 294px;
    height: 194px;
    position: absolute;
  }

  .task-intro-title {
    border-bottom: 1px solid #fff;
    margin-bottom: 16px;
    margin-left: 150px;
    line-height: 56px;
    height: 57px;
    font-size: 24px;
    font-weight: 600;
  }

  .task-intro-text {
    margin-left: 150px;
    margin-bottom: 21px;
    font-size: 16px;
    font-weight: 600;
    opacity: 0.6;
    color: #FFFFFF;
  }

  .box3-params {
    z-index: 999;
    color: #FFFFFF;
    margin-left: calc((100% - 1280px) / 2);
    margin-top: 1100px;
    padding-bottom: 150px;
    width: 1280px;
  }

  .params-title {
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    font-size: 48px;
    font-weight: 600;
    padding-bottom: 30px;
    margin-bottom: 75px;
  }

  .params-grid {
    font-size: 24px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    column-gap: 2px;
    row-gap: 135px;
  }

  .params-grid-item {
    padding-left: 70px;
    font-weight: 600;
  }

  .grid-item-text {
    margin-top: 24px;
    display: flex;
    font-size: 16px;
  }

  .grid-line {
    margin-right: 18px;
    width: 2px;
    height: 22px;
    opacity: 0.4;
    background: #FFFFFF;
  }

  .grid-tip {
    flex: 1;
    line-height: 32px;
    font-size: 16px;
  }
}

// 移动端
@media all and (min-width: 320px) and (max-width: 768px) {
  .template-container {
    overflow: hidden;
    min-width: 0;
    width: 100%;

    .content-box {
      width: 100%;
    }

    .main-box1 {
      display: flex;
      align-items: flex-end;
      justify-content: center;
      background-size: cover;
      background-image: url("/static/images/v2/600h/600h_bg1.png");
      background-position: center;
      width: 100%;
      height: calc(100vh - 60px);

      .box1-intro {
        padding: 0 20px;
        font-size: 16px;
        font-weight: 600;
        line-height: 22px;
      }

      .text-box {
        width: 100%;
        color: #fff;
        margin-bottom: 50px;
      }

      .img-lj {
        display: none;
        width: 52px;
        height: 52px;
        margin-right: 15px;
      }

      .text-item {
        color: #C1C7C9;
        font-size: 24px;
        font-weight: 500;
        width: 225px;
      }

      .text-top {
        padding-left: 20px;
        align-items: center;
        width: 100%;
        display: flex;
        padding-bottom: 20px;
        border-bottom: 1px solid #C0C1BD;
        margin-bottom: 40px;
      }

      .top-text1 {
        width: 90vw;
        color: #FFFFFF;
        font-size: 64px;
        font-weight: 800;
        margin-bottom: 12px;
      }

      .top-text2 {
        display: none;
        color: #FFFFFF;
        font-size: 36px;
        font-weight: 900;
        margin-bottom: 12px;
      }
      .top-text2-1{
        display: none;
      }
    }

    .main-box2 {
      position: relative;
      background-size: cover;
      background-image: url("/static/images/v2/600h/600h_bg2.png");
      width: 100%;
      height: 1100px;

      .main-box2-img {
        width: 100%;
        height: auto;
        position: absolute;
        transform: rotate(-45deg);
        top: 10px;
        left: 18px;
        z-index: 0
      }
    }

    .box2-right {
      z-index: 3;
      position: absolute;
      padding-top: 254px;
      border: 0 solid #4D4D4D;
      background: none;
      width: 100%;
      margin-left: 0;
    }

    .box2-item {
      margin-left: 23px;
      margin-bottom: 17px;
      display: flex;
    }

    .box2-item-title {
      margin-top: 11px;
      font-size: 24px;
      font-weight: 600;
      color: #90EEBD;
    }

    .box2-item-text {
      margin-top: 11px;
      width: 266px;
      font-size: 14px;
      font-weight: 600;
      line-height: 22px;
      color: #DCDCDC;
    }

    .img-icon {
      margin-right: 27px;
      width: 44px;
      height: 44px;
    }

    .box2-bottom {
      padding: 0 20px;
      z-index: 90;
      left: 0;
      position: absolute;
      top: 1200px;
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 16px;
      font-weight: 600;
      line-height: 22px;
      color: #FFFFFF;
    }

    .box2-bottom-list {
      width: 100%;
      display: flex;
      border-top: 1px solid #4D4D4D;
      margin-top: 15px
    }

    .box2-bottom-title {
      line-height: 48px;
      font-size: 48px;
      font-weight: 600;
      background: linear-gradient(167deg, #7DDAFF 30%, #1E92F7 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      margin-bottom: 20px;
    }

    .box2-bottom-img {
      margin-top: 15px;
      width: auto;
      height: 150px;
    }

    .box2-bottom-img2 {
      object-fit: cover;
      width: 100px;
      margin-top: 10px;
      margin-left: 10px;
      flex: 1;
      height: auto;
    }

    .main-box3 {
      position: relative;
      background-size: cover;
      background-image: url("/static/images/v2/600h/600h_bg3.png");
      width: 100%;
      height: auto;
    }

    .triangle-clip1 {
      bottom: 0;
      z-index: 5;
      position: absolute;
      width: 100%;
      height: auto;
      background: linear-gradient(0deg, #0C0C0C 0%, rgba(0, 0, 0, 0) 100%);
    }

    .triangle-clip {
      top: -1px;
      z-index: 2;
      position: absolute;
      width: 100%;
      height: 30.34vw;
      background-color: #0C0C0C;
      clip-path: polygon(0% 0%, 0% 100%, 100% 0%);
    }

    .box3-op {
      width: 100%;
      height: 100%;
      position: absolute;
      opacity: 0.7;
      background: linear-gradient(165deg, #fff 1%, rgba(9, 117, 65, 1) 30%);;
    }

    .box3-task {
      margin-left: 0;
      width: 100%;
      height: 30vh;
    }

    .box3-logo {
      object-fit: cover;
      object-position: left;
      z-index: 5;
      position: absolute;
      top: 600px;
      left: 20px;
      width: 100%;
      height: auto;
    }

    .box3-task-text {
      left: 2%;
      font-size: 24px;
      color: #FFF;
      z-index: 5;
      position: absolute;
      width: 100%;
      top:700px;
      right: 0;
      padding-bottom: 25px;
    }

    .box3-task-title {
      margin-top: 12vw;
      font-size: 48px;
      font-weight: 600;
      margin-bottom: 60px;
    }

    .task-item-box {
      display: flex;
      margin-top: 12px;
      margin-bottom: 30px;
    }

    .task-item-text {
      cursor: pointer;
      margin-right: 13px;
      font-size: 12px;
      font-weight: 600;
      line-height: 30px;
      text-align: center;
      min-width: 98px;
      height: auto;
      border-radius: 3px;
      border: 1px solid #FFFFFF;
    }

    .task-item-text2 {
      background: #FFFFFF;
      color: #626262;
    }

    .task-intro-box {
      position: relative;
      border-radius: 12px;
      width: 95%;
      height: auto;
      background: linear-gradient(0deg, rgba(111, 180, 146, 0.59) 0%, #387758 100%);
      border: 1px solid rgba(255, 255, 255, 0.51);
    }

    .task-intro-img {
      left: -70px;
      top: -65px;
      width: 294px;
      height: 194px;
      position: absolute;
    }

    .task-intro-title {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #fff;
      margin-bottom: 16px;
      margin-left: 150px;
      min-height: 50px;
      line-height: 20px;
      height: auto;
      font-size: 14px;
      font-weight: 600;
    }

    .task-intro-text {
      margin-left: 150px;
      margin-bottom: 21px;
      font-size: 12px;
      font-weight: 600;
      opacity: 0.6;
      color: #FFFFFF;
    }

    .box3-params {
      z-index: 999;
      color: #FFFFFF;
      margin-left: 5vw;
      margin-top: 1400px;
      padding-bottom: 150px;
      width: 90vw;
    }

    .params-title {
      border-bottom: 1px solid rgba(255, 255, 255, 0.2);
      font-size: 48px;
      font-weight: 600;
      padding-bottom: 30px;
      margin-bottom: 75px;
    }

    .params-grid {
      font-size: 24px;
      display: grid;
      grid-template-columns: 1fr 1fr;
      column-gap: 2px;
      row-gap: 135px;
    }

    .params-grid-item {
      padding-left: 20px;
      font-weight: 600;
    }

    .grid-item-text {
      margin-top: 24px;
      display: flex;
      font-size: 16px;
    }

    .grid-line {
      margin-right: 18px;
      width: 2px;
      height: 22px;
      opacity: 0.4;
      background: #FFFFFF;
    }

    .grid-tip {
      flex: 1;
      line-height: 32px;
      font-size: 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/industry/hw600.vue